// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3NSQA","range":"MonthRangeSwitch_range__3WXg6","disabled":"MonthRangeSwitch_disabled__gvZE4"};